export default "__VITE_ASSET__aBc2UzDr__"